import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from '../environments/environment';
import { AlertComponent, CustomMissingTranslationHandler } from '@balloon-race-fullstack-monorepo/dbr-common';
import { KeepAwake } from '@capacitor-community/keep-awake';

/**
 * Create a custom translation loader
 * @param httpClient
 * @returns {TranslateHttpLoader}
 */
export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, ENVIRONMENT.TRANSLATION_PATH, '.json');
}

/**
 * Factory for CustomMissingTranslationHandler
 *
 * @returns {CustomMissingTranslationHandler}
 */
export function createCustomMissingTranslationHandler() {
  return new CustomMissingTranslationHandler();
}

@Component({
    imports: [RouterModule, AlertComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'dbr-creator-box-app';
  private translateService = inject(TranslateService);

  constructor() {
    this.translateService.setDefaultLang('de');
    this.translateService.use('de');

    this.initAwake();
  }

  private initAwake(): void {
    if (!KeepAwake) {
      console.warn("plugin KeepAwake not available");
      return;
    }
    KeepAwake.isSupported().then((isSupportedResult) => {
      if (isSupportedResult.isSupported) {
        KeepAwake.keepAwake();
      }
    });
  }
}
